export function selectItem(selected) {
  return {
    type: "SELECT_ITEM",
    selected,
  };
}
